module.exports = __webpack_public_path__ + "static/img/vrroad_img1.cfca9f97.png";